var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TAG_COLORS } from "./constants";
export var getNextColor = function (options) {
    var colorCounts = options.reduce(function (acc, cur) {
        acc[cur.color] += 1;
        return acc;
    }, __assign({}, TAG_COLORS));
    return Object.keys(colorCounts).reduce(function (key, v) {
        return colorCounts[v] < colorCounts[key] ? v : key;
    });
};
